import React from 'react';
import { Grid, Button, Responsive, Image } from 'semantic-ui-react';
import BrowserDetection from 'react-browser-detection';
import PoweredByDyzio from '../../components/powered-by-dyzio';
import BrowserHandler from '../../utils/browser-handler';
import { authService } from '../../utils/auth-service';
import ThemeSelector from '../../themes/theme-selector';

const viewportStyles = {
  backgroundColor: '#f7fafa',
  height: 'auto',
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '64px 24px',
};

const signupBoxStyle = {
  background: 'white',
  border: '1px solid #e8e8e8',
  borderRadius: '4px',
  padding: '24px',
  maxWidth: '960px',
  margin: '0 auto',
};

const gridStyle = {
  minHeight: 300,
};

const NewInfluencerSignup = () => {
  const theme = ThemeSelector.theme();
  const { copy: { featureList, joinTitle, joinDescription } } = theme;

  return (
    <div style={viewportStyles}>
      <div className="align-center">
        <Responsive minWidth={300} maxWidth={599}>
          <Image size="large" src={theme.darkLogo.src} centered />
        </Responsive>

        <Responsive minWidth={600}>
          <Image size="big" src={theme.darkLogo.src} centered />
        </Responsive>

        <div className="spacer" />
        <h2>{joinTitle}</h2>
        <p>{joinDescription}</p>
        <div className="spacer large" />
        <div style={signupBoxStyle}>
          <Grid columns={2} stackable divided style={gridStyle}>
            <Grid.Row verticalAlign="middle">
              <Grid.Column>
                <Button
                  content="Sign up with Instagram"
                  inverted color="pink"
                  icon="instagram"
                  size="large"
                  onClick={() => {
                    const { origin } = window.location;
                    const options = {
                      prompt: 'login',
                      redirectUri: `${window.location.origin}/influencer-auth`,
                      logo: `${origin}${theme.darkLogo.src}`,
                    };
                    authService.socialLogin(options);
                  }}
                />
              </Grid.Column>
              <Grid.Column className="align-left">
                {featureList}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>

        <div className="spacer" />

        <PoweredByDyzio />
        <BrowserDetection>
          {BrowserHandler.handle}
        </BrowserDetection>

      </div>
    </div>
  );
};

export default NewInfluencerSignup;



/** WEBPACK FOOTER **
 ** ./src/containers/new-influencer-signup/index.js
 **/